
(() => {
  if (window.spHalloweenInstalled) return;
  window.spHalloweenInstalled = true;
  document.addEventListener('click', async (event) => {
    const copy = event.target.closest('[data-sp-copy]');
    if (copy) {
      const label = copy.querySelector('span');
      try {
        await navigator.clipboard.writeText('HALLO26');
        if (label) label.textContent = copy.dataset.copied;
      } catch {
        if (label) label.textContent = copy.dataset.failed;
        const range = document.createRange();
        range.selectNodeContents(copy.querySelector('b'));
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
    const filter = event.target.closest('[data-sp-filter]');
    if (filter) {
      const section = filter.closest('.sp-hw-products');
      section.querySelectorAll('[data-sp-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
      section.querySelectorAll('[data-sp-group]').forEach(card => { card.hidden = filter.dataset.spFilter !== 'all' && card.dataset.spGroup !== filter.dataset.spFilter; });
    }
  });
  function checkEnd() {
    const live = document.body.dataset.spHalloweenLive === 'true';
    const end = Date.parse('2026-11-03T00:00:00+01:00');
    if (live && Date.now() >= end) {
      document.body.classList.remove('sp-halloween-active');
      document.querySelectorAll('.sp-hw-seasonal').forEach(element => { element.hidden = true; });
    }
  }
  checkEnd();
  document.addEventListener('visibilitychange', checkEnd);
  setInterval(checkEnd, 60000);
})();
